import api from './api';
import type { RelationshipType } from './family-tree.service';

export interface WillBeneficiary {
  id: string;
  familyMemberId: string;
  percentage: number;
  createdAt: string;
  updatedAt: string;
  familyMember: {
    id: string;
    memberId: string;
    firstName: string;
    lastName: string | null;
    relationship: RelationshipType;
    passportNumber: string | null;
    email: string | null;
    isDeceased: boolean;
  };
}

export interface WillPricing {
  displayAmount: number;
  displayCurrency: string;
  chargeAmountMYR: number;
  conversionRate: number;
  formatted: string;
}

export interface WillData {
  beneficiaries: WillBeneficiary[];
  totalPercentage: number;
  unlocked: boolean;
  unlockedAt?: string | null;
  pricing?: WillPricing;
}

export interface BeneficiaryInput {
  familyMemberId: string;
  percentage: number;
}

export interface GatewayPaymentResponse {
  referenceNo: string;
  amount: number;
  displayCurrency: string;
  displayAmount: number;
  paymentUrl: string;
}

export const willService = {
  async getWill(): Promise<WillData> {
    const response = await api.get<WillData>('/will');
    return response.data;
  },

  /** Replace the full beneficiary list; server enforces a 100% total. */
  async updateBeneficiaries(beneficiaries: BeneficiaryInput[]): Promise<WillData> {
    const response = await api.put<WillData>('/will/beneficiaries', { beneficiaries });
    return response.data;
  },

  /** Unlock the letter, paying from the wallet balance (instant). */
  async purchaseWithWallet(): Promise<WillData> {
    const response = await api.post<WillData>('/will/purchase/wallet');
    return response.data;
  },

  /** Start the gateway payment; returns the AiAhad payment URL to open. */
  async purchaseWithGateway(): Promise<GatewayPaymentResponse> {
    const response = await api.post<GatewayPaymentResponse>('/will/purchase/gateway');
    return response.data;
  },
};
